export const focusAreas = {
  strategyPlanning: {
    title: "Strategic Content Planning",
    icon: "CalendarMonth",
    symptoms: [
      "Publishing content inconsistently or sporadically",
      "No clear goals or metrics for content success",
      "Content doesn't align with business objectives",
      "Unclear target audience or customer personas"
    ],
    impacts: [
      "Wasted time and resources on ineffective content",
      "Missed opportunities to attract and nurture leads",
      "Inconsistent brand message across channels",
      "Difficulty proving content marketing ROI to stakeholders"
    ],
    solutions: [
      "Develop comprehensive content strategy aligned with business goals",
      "Create detailed buyer personas for Saskatchewan market",
      "Build editorial calendar with consistent publishing schedule",
      "Define clear KPIs and measurement framework",
      "Conduct competitive content analysis in your industry",
      "Map content to different stages of customer journey"
    ],
    nextSteps: [
      "Audit existing content performance and gaps",
      "Define your content marketing objectives and KPIs",
      "Create buyer personas based on customer research",
      "Develop 90-day content calendar with topics and formats"
    ],
    insight: "Strategic planning is the foundation of successful content marketing. Companies with a documented content strategy are 313% more likely to report success. A clear strategy ensures every piece of content serves a purpose in moving your Saskatchewan customers closer to a purchase decision."
  },
  contentCreation: {
    title: "High-Impact Content Creation",
    icon: "Create",
    symptoms: [
      "Content quality is inconsistent or low",
      "Limited variety in content formats (only blog posts)",
      "Content doesn't address customer pain points",
      "Difficulty maintaining consistent publishing schedule"
    ],
    impacts: [
      "Low engagement and interaction from your audience",
      "Failing to establish thought leadership in your industry",
      "Missing opportunities to connect with different learning styles",
      "Poor search rankings due to thin or low-quality content"
    ],
    solutions: [
      "Create comprehensive, high-quality content that solves problems",
      "Develop diverse content formats: blogs, videos, infographics, podcasts",
      "Build content creation process and editorial workflows",
      "Leverage local Saskatchewan stories and case studies",
      "Implement content optimization for search and user experience",
      "Create pillar content to establish topical authority"
    ],
    nextSteps: [
      "Identify top customer questions and pain points",
      "Create content brief template for consistent quality",
      "Invest in content creation tools and resources",
      "Develop signature content pieces (guides, resources)"
    ],
    insight: "Quality trumps quantity in content marketing. 72% of marketers say relevant content creation is the most effective SEO tactic. Creating valuable, diverse content formats helps you reach different audience preferences while establishing your expertise in the Saskatchewan market."
  },
  distributionEngagement: {
    title: "Content Distribution & Engagement",
    icon: "Share",
    symptoms: [
      "Great content that nobody sees or engages with",
      "Relying on only one or two distribution channels",
      "No strategy for promoting or amplifying content",
      "Low social shares, comments, or interactions"
    ],
    impacts: [
      "Limited reach and visibility for your content investment",
      "Missing target audience on their preferred platforms",
      "Poor lead generation despite quality content",
      "Difficulty building community and brand loyalty"
    ],
    solutions: [
      "Implement multi-channel distribution strategy",
      "Build email marketing campaigns around content themes",
      "Optimize content for social sharing and engagement",
      "Leverage employee advocacy and influencer partnerships",
      "Create community engagement plan with response protocols",
      "Use paid promotion to amplify high-performing content",
      "Repurpose content across multiple formats and channels"
    ],
    nextSteps: [
      "Map your audience's preferred content channels",
      "Create content promotion checklist for each piece",
      "Build email list and segmentation strategy",
      "Set up social media scheduling and engagement plan"
    ],
    insight: "Creating content is only half the battle - distribution determines success. 60% of the most successful marketers have a documented distribution strategy. By strategically promoting your content across multiple channels, you ensure your Saskatchewan audience discovers and engages with your expertise."
  }
};
